var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-radio-button",class:[
    _vm.radioButtonChecked ? 'ui-radio-button--checked' : null,
    _vm.isDisabled ? 'ui-radio-button--disabled' : null,
  ]},[_c('span',{staticClass:"ui-radio-button__radio-button"}),_c('span',{staticClass:"ui-radio-button__text"},[_vm._v(_vm._s(_vm.radioButtonText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }